// 集卡
const collectCardIndex = () => import('../pages/collectCard/index.vue');
export default [
  {
    path: '/collectCardIndex',
    component: collectCardIndex,
  },
];
